$(function () {
  $('#opened').bind('click', function () {
    const $this = $(this)
    $('#drawer').show(function () {
      $this.toggleClass('active')
      $(this).toggleClass('active')
    })
  })

  // 弹窗内容
  $('#works').on('click', '.card-item', function () {
    var htmlId = $(this).attr('data-href')
    var htmlElem = $(htmlId)
    var htmlText = htmlElem.length > 0 ? htmlElem.html() : ''
    $('body').addClass('hidden')
    $('#popupLayer').addClass('show')
    $('#popupLayerText').html(htmlText)
  })

  // 关闭弹窗
  $('#closed').bind('click', function () {
    $('body').removeClass('hidden')
    $('#popupLayer').removeClass('show')
  })

  $('.popup-pane').bind('wheel', function (event) {
    event.stopPropagation()
  })

  // 菜单
  const $menus = $('#drawer').find('.header-menu_item  a')
  function takeHash() {
    var aid = window.location.hash
    $menus.each(function () {
      const href = $(this).attr('href')
      if (aid === href) {
        $(this).parent().addClass('active').siblings().removeClass('active')
      }
    })
  }

  window.addEventListener('hashchange', takeHash, false)
})
